"use client";

import Typography from "@/shared/components/common/Typography";
import data from "@/public/data/hotel/results.json";
import { CaretLeft } from "@phosphor-icons/react";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator,
} from "./BreadcrumbItem";
import PhosphorIcon from "../PhosphorIcon";

interface BreadCrumbProps {
  page: "result" | "detail";
  city: string;
  hotel?: {
    code: string;
    persian: string;
  };
}

export default function BreadCrumb({ page, city, hotel }: BreadCrumbProps) {
  const {
    body: {
      breadcrumb: { b1, b2 },
    },
  } = data;

  return (
    <Breadcrumb className="px-2">
      <BreadcrumbList>
        <BreadcrumbItem>
          <BreadcrumbLink
            className="text-muted-foreground hover:text-foreground dark:text-foreground hover:dark:text-foreground/80"
            href={`${b1.href}/`}
          >
            <Typography variant="body1" className="font-medium max-md:!text-sm">
              {b1.label}
            </Typography>
          </BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbSeparator>
          <PhosphorIcon
            name="CaretLeft"
            size={14}
            weight="light"
            className="text-muted-foreground dark:text-foreground/70"
          />
        </BreadcrumbSeparator>
        <BreadcrumbItem>
          <BreadcrumbLink
            href={hotel?.code ? `${b2.href}/${hotel?.code}/` : undefined}
            className={`text-muted-foreground hover:text-foreground dark:text-foreground hover:dark:text-foreground/80 ${
              page === "result" && "hover:text-muted-foreground"
            }`}
          >
            <Typography variant="body1" className="font-medium max-md:!text-sm">
              {b2.label} {city}
            </Typography>
          </BreadcrumbLink>
        </BreadcrumbItem>
        {page === "detail" && (
          <>
            <BreadcrumbSeparator>
              <PhosphorIcon
                name="CaretLeft"
                size={14}
                weight="light"
                className="text-muted-foreground dark:text-foreground/70"
              />
            </BreadcrumbSeparator>
            <BreadcrumbItem>
              <BreadcrumbLink className="text-muted-foreground hover:text-foreground dark:text-foreground">
                <Typography
                  variant="body1"
                  className="font-medium max-md:!text-sm"
                >
                  {hotel?.persian}
                </Typography>
              </BreadcrumbLink>
            </BreadcrumbItem>
          </>
        )}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
